import { createAction, props } from '@ngrx/store';

export const setMoonshotEnabled = createAction(
  '[Moonshot] Set Moonshot Enabled',
  props<{ enabled: boolean }>()
);

export const setUserPatientId = createAction(
  '[Moonshot] Set User Patient ID',
  props<{ patientId: string | null }>()
);

export const resetMoonshotState = createAction('[Moonshot] Reset State');

export const MoonshotActions = {
  setMoonshotEnabled,
  setUserPatientId,
  resetMoonshotState,
};
